import angular from 'angular';
import createCustomerComponent from './createCustomer.component';

let createCustomerModule = angular.module('createCustomer', []).component('createCustomer', createCustomerComponent);

export default createCustomerModule;



// WEBPACK FOOTER //
// ./app/components/createCustomer/createCustomer.js